import React from "react";
import { X } from "lucide-react";
import { usePlayer, EQ_PRESETS } from "@/context/PlayerContext";

const BANDS = [
  { key: "bass", label: "60Hz" },
  { key: "low", label: "250" },
  { key: "mid", label: "1K" },
  { key: "high", label: "4K" },
  { key: "treble", label: "12K" },
];

export default function EQPanel({ onClose }) {
  const { eq, applyEQ, applyPreset } = usePlayer();

  const setBand = (key, val) => {
    applyEQ({ ...eq, [key]: val, preset: "custom" });
  };

  return (
    <div
      data-testid="eq-panel"
      className="fixed bottom-24 left-1/2 -translate-x-1/2 z-50 w-[92%] max-w-lg glass border border-white/10 p-5"
    >
      <div className="flex items-center justify-between mb-4">
        <div>
          <div className="font-heading font-black text-base tracking-tight">GRAPHIC EQ</div>
          <div className="font-mono-tech text-[10px] uppercase tracking-widest text-slate-500">5-BAND · ±12dB</div>
        </div>
        <button
          data-testid="eq-close"
          onClick={onClose}
          className="w-8 h-8 flex items-center justify-center text-slate-400 hover:text-white border border-[var(--voix-border)]"
        >
          <X size={14} />
        </button>
      </div>

      {/* Bands */}
      <div className="flex items-end justify-between gap-3 mb-5 h-40 px-2">
        {BANDS.map((b) => (
          <div key={b.key} className="flex flex-col items-center gap-2 flex-1">
            <div className="font-mono-tech text-[10px] text-cyan-400">{(eq[b.key] || 0).toFixed(0)}dB</div>
            <input
              data-testid={`eq-band-${b.key}`}
              type="range"
              min={-12}
              max={12}
              step={1}
              value={eq[b.key] || 0}
              onChange={(e) => setBand(b.key, parseInt(e.target.value))}
              className="voix-slider"
              style={{ writingMode: "bt-lr", WebkitAppearance: "slider-vertical", width: 6, height: 100 }}
            />
            <div className="font-mono-tech text-[10px] uppercase tracking-widest text-slate-500">{b.label}</div>
          </div>
        ))}
      </div>

      {/* Presets */}
      <div className="flex flex-wrap gap-2">
        {Object.keys(EQ_PRESETS).map((name) => (
          <button
            key={name}
            data-testid={`eq-preset-${name}`}
            onClick={() => applyPreset(name)}
            className={`text-[10px] font-mono-tech uppercase tracking-widest px-2.5 py-1.5 border transition ${
              eq.preset === name
                ? "border-yellow-500 text-yellow-300 bg-yellow-500/10"
                : "border-[var(--voix-border)] text-slate-400 hover:border-yellow-500/60 hover:text-yellow-300"
            }`}
          >
            {name}
          </button>
        ))}
      </div>
    </div>
  );
}
